"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDateRangeFieldValue = exports.getDateRangeFieldEmptyValue = void 0;
const getDateRangeFieldEmptyValue = () => {
    return {
        from_date: {
            date: null,
            include_time: false,
        },
        to_date: {
            date: null,
            include_time: false,
        },
    };
};
exports.getDateRangeFieldEmptyValue = getDateRangeFieldEmptyValue;
const generateDateRangeFieldValue = (value) => {
    var _a, _b;
    return {
        from_date: (_a = value.from_date) !== null && _a !== void 0 ? _a : {
            date: null,
            include_time: false,
        },
        to_date: (_b = value.to_date) !== null && _b !== void 0 ? _b : {
            date: null,
            include_time: false,
        },
    };
};
exports.generateDateRangeFieldValue = generateDateRangeFieldValue;
